import { GALLERY_v4_CONSTS } from '@wix/photography-client-lib';
// use base styles
export var getBaseStyles = function (galleryStyles) {
    var _a;
    var baseStyles = {
        cubeType: GALLERY_v4_CONSTS.cubeType.FIT,
        itemClick: GALLERY_v4_CONSTS.itemClick.NOTHING,
        galleryLayout: GALLERY_v4_CONSTS.layout.SLIDESHOW,
        textBoxHeight: 0,
        videoSound: true,
        showVideoControls: true,
        arrowsPadding: 10,
        videoLoop: !!(galleryStyles === null || galleryStyles === void 0 ? void 0 : galleryStyles.videoLoop),
        videoPlay: GALLERY_v4_CONSTS.videoPlay.AUTO,
        isRTL: !!(galleryStyles === null || galleryStyles === void 0 ? void 0 : galleryStyles.isRTL),
        useMaxDimensions: true,
        enableVideoPlaceholder: !!(galleryStyles === null || galleryStyles === void 0 ? void 0 : galleryStyles.enableFullscreenVideoPlaceholder),
        stylingParams: {
            itemResolutionMode: (((_a = galleryStyles === null || galleryStyles === void 0 ? void 0 : galleryStyles.stylingParams) === null || _a === void 0 ? void 0 : _a.itemResolutionMode) || ''),
        },
    };
    return baseStyles;
};
//# sourceMappingURL=proGallerySliderFixedStyles.js.map